document.addEventListener("DOMContentLoaded", function () {
  const template = document.documentElement.getAttribute("data-template");

  // If HOME PAGE (index), don't lazy-load banners
  if (template === "index") {
    document.querySelectorAll(".banner img, .hero img").forEach(img => {
      img.loading = "eager";
    });
    return;
  }

  // All other pages → Lazy loading on all images
  document.querySelectorAll("img").forEach(img => {
    if (!img.loading) {
      img.loading = "lazy";
    }
  });
});


